<div *ngIf="isLoading" class="loading" data-testid="loading">
  <img src="../../../../assets/images/loading.svg" alt="Loading" />
</div>